import { AIRLINES } from '../constants/appConstants';

export const formatFlightNumber = (flightNum: string, airline: string): string => {
  if (!flightNum) return '';

  // Remove non-numeric characters
  const numericFlightNum = flightNum.replaceAll(/\D/g, '');

  // Ensure at least 4 digits, padding with zeros if needed
  const paddedFlightNum = numericFlightNum.padStart(4, '0');

  // Prefix with airline code
  if (airline === AIRLINES.AS) return `AS${paddedFlightNum}`;
  if (airline === AIRLINES.QX) return `QX${paddedFlightNum}`;
  return flightNum;
};

export const isValidFlightNumber = (flightNum: string, ranges: number[][]): boolean => {
  const num = Number.parseInt(flightNum.replaceAll(/\D/g, ''), 10);

  if (Number.isNaN(num)) return false;

  return ranges.some(([start, stop]) => num >= start && num <= stop);
};

export const formatDateToCustom = (date: Date): string => {
  const pad = (num: number, size: number = 2): string => num.toString().padStart(size, '0');

  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1); // Months are zero-based
  const year = date.getFullYear();

  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  return `${month}-${day}-${year} ${hours}:${minutes}:${seconds}Z`;
};

export const calculateRelativeRange = (value: number, unit: 'min' | 'hours' | 'days'): { start: Date; end: Date } => {
  const now = new Date();
  const end = new Date(now);
  let start = new Date(now);

  switch (unit) {
    case 'min':
      start.setMinutes(start.getMinutes() - value);
      break;
    case 'hours':
      start.setHours(start.getHours() - value);
      break;
    case 'days':
      start.setDate(start.getDate() - value);
      break;
    default:
      start.setMinutes(start.getMinutes() - value);
  }

  return { start, end };
};
